<form [formGroup]="branchFundingForm" class="{{ApplicantLoanComponent.currentChannel?.channelName}}">

  <!-- Input deposit accounts -->
  <div class="row">
    <div class="col-12">
      <p class="mb-3 segment-title text-left">Enter the amount to deposit for each account: </p>
    </div>
    <div class="col-12">
      <div class="row" style="margin: 0; padding:0;">
        <div class="col-md-6">
          <div class="segment-content text-left" *ngFor="let aa of interestedAccounts">
            <div style="font-weight: bold;">
              <span>{{aa.account_name}}</span>
              <mat-hint style="color:#3a94cb; margin-left: 5px;">min deposit: ${{aa.min_deposit}}</mat-hint>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>Total Deposit</mat-label>
              <input matInput formControlName="{{aa.account_name}}" (blur)="unfocusTotalDeposit($event.target.value)"
                mask="separator.2" prefix="$" thousandSeparator="," name="amount_deposit" [min]="aa.min_deposit"
                [(ngModel)]="aa.amount_deposit" required (ngModelChange)="onChangeAmountDeposit()">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Total deposit -->
  <div class="row mt-3">
    <div class="col-12">
      <p class="mb-3 segment-title text-left">Total Amount of Deposit: <span style="color:#3a94cb"> {{ totalDeposit |
          currency }}</span></p>
    </div>
  </div>

  <!-- Methods -->
  <div class="row mt-3" *ngIf="!isSelectedMethod">
    <div class="col-12">
      <p class="mb-3 segment-title text-left">Select a method to fund your account:</p>
    </div>

    <div class="col-12">
      <div class="row" style="margin: 0; padding:0;">
        <div class="col-md-8 mb-3" *ngFor="let item of fundingSources; let i = index;"
          [ngClass]="{'selected': item.isSelected}" [ngStyle]="{'opacity': isSelectedMethod ? '0.5' : '1', 
              'cursor': isSelectedMethod ? 'default' : 'pointer', 
              'display': ((maxDeposit && totalDeposit > maxDeposit) || (!maxDeposit && totalDeposit > item.maxDeposit) || (isSelectedMethod && !item.isSelected) )? 'none': 'block'}"
          (click)="selectFundingMethod(item,i, $event)">
          <div class="fund-option">
            <img [src]="'../../../assets/images/fundings/' + item.imageLink" style="width: 60px;height: 60px;" alt="">
            <div class="fund-option-content">
              <h6>{{item.displayName}}<span class="badge">{{item.isRecommended ? 'Recommended' : ''}}</span></h6>
              <p [innerHTML]="item.helperText"></p>
            </div>
            <mat-icon class="fund-icon-right">chevron_right</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirm funding -->
  <div class="row mt-3" *ngIf="isSelectedMethod">
    <div class="col-12">
      <p class="mb-3 segment-title text-left">Confirm your funding information below:</p>
    </div>

    <div class="col-12">
      <div class="row" style="margin: 0; padding: 0;">
        <div class="col-md-6">
          <div class="method-selected">
            <div style="display: flex; justify-content: space-between; padding: 0px 10px">
              <!-- <p style="font-weight: 600;">{{(selectedFundingSource?.displayName) ? selectedFundingSource?.displayName +' Details' : ''}}</p> -->
              <p style="font-weight: 600;">{{selectedFundingSource.funding_Type == 1 ? 'Debit or Credit Card ' :'Bank
                Transfer '}} Details</p>
              <p>
                <span (click)="openConfirmRemoveFundingSource()"
                  style="font-size: 15px; font-weight: bold; color:#3a94cb; cursor: pointer;">delete</span>
              </p>
            </div>

            <div class="p-2 bank-item d-flex">
              <label style="flex: 2; min-width: 200px;" *ngIf="selectedFundingSource.funding_Type == 2">Total Transfer
                Amount</label>
              <label style="flex: 2; min-width: 200px;" *ngIf="selectedFundingSource.funding_Type == 1">Total
                Authorization Amount</label>
              <label style="font-weight: 600; margin-left: 10px; flex: 1;color:#000">{{ totalDeposit | currency
                }}</label>
            </div>
            <div class="p-2 bank-item d-flex">
              <label style="flex: 2; min-width: 200px;" *ngIf="selectedFundingSource.funding_Type == 2">Last Four of
                Account Number</label>
              <label style="flex: 2; min-width: 200px;" *ngIf="selectedFundingSource.funding_Type == 1">Last Four of
                Card Number</label>
              <label style="font-weight: 600; margin-left: 10px; flex: 1; color:#000"
                *ngIf="selectedFundingSource.funding_Type == 2 && bankDetails && bankDetails.bank_account_number">{{last4AccountNumber(bankDetails.bank_account_number)}}</label>
              <label style="font-weight: 600; margin-left: 10px; flex: 1;color:#000"
                *ngIf="selectedFundingSource.funding_Type == 1 && cardDetails && cardDetails.cardNumber">{{last4AccountNumber(cardDetails.cardNumber)}}</label>
            </div>
            <div class="p-2 bank-item d-flex">
              <label style="flex: 2; min-width: 200px;"
                *ngIf="selectedFundingSource.funding_Type == 1">Expiration</label>
              <label style="flex: 2; min-width: 200px;" *ngIf="selectedFundingSource.funding_Type == 2">Financial
                Institution</label>
              <label style="font-weight: 600; margin-left: 10px; flex: 1;color:#000; word-break: keep-all;"
                *ngIf="selectedFundingSource.funding_Type == 2 && bankDetails && bankDetails.bank_bankname">{{bankDetails.bank_bankname}}</label>
              <label style="font-weight: 600; margin-left: 10px; flex: 1;color:#000"
                *ngIf="selectedFundingSource.funding_Type == 1 && cardDetails  && cardDetails.expirationMonth && cardDetails.expirationYear">{{expirationDateCreditCard(cardDetails.expirationMonth
                , cardDetails.expirationYear)}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <hr style="width:100%; height: 1px; color: #E9ECEF;">
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12" *ngIf="helperTextFundingPage?.contents && helperTextFundingPage?.contents.length>0">
      <div class="row" style="margin: 0; padding:0;">
        <div class="col-12 box-helper-text">
          <ng-container *ngFor="let content of helperTextFundingPage?.contents; let i = index;">
              <p style="font-size: 15px; margin-top: 15px;" >{{content}}</p>
              <ng-container *ngIf="i==0">
                <div class="expansion-panel" [ngStyle]="{'background-color': isConsentOpen ? 'white' : '#E9ECEF'}">
                  <div class="panel-header" (click)="isConsentOpen = !isConsentOpen">
                    <mat-icon class="expand-icon"  [ngStyle]="{'background-color': isConsentOpen ? 'white' : ''}">{{ isConsentOpen ? 'remove' : 'add' }}</mat-icon>
                    <p>{{isConsentOpen ? 'Collapse':'Learn More'}} </p>
                  </div>    
                  <div class="panel-content" *ngIf="isConsentOpen"  [ngStyle]="{'padding-left': AppComponent.isDesktop ? '75px' : '20px',  'opacity': isConsentOpen ? '1' : '0', 'transition': 'max-height 0.5s ease, opacity 0.5s ease'}">
                    <p class="helper-text"> 
                      {{helperTextFundingPage?.learnMore}}Learn more at <a href="https://plaid.com/" target="_blank">Plaid.com</a>
                      </p>
                  </div>
                </div>
              </ng-container>
          </ng-container>        
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-3" mat-dialog-actions>
    <div class="col-md-2" *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
      Loading...
    </div>
    <div class="col-md-12" *ngIf="!isLoading">
      
      <div *ngIf="isCallBack && messageErrors.length>0">
        <ul class="err-list col">
          <ng-container *ngFor="let error of messageErrors">
            <li>
              <mat-error class="error-message">
                ❋ {{error}}
              </mat-error>
            </li>
          </ng-container>
        </ul>
      </div>

      <div *ngIf="captchaRequired">
        <form [formGroup]="reactiveForm">
          <re-captcha siteKey="6Lc789QZAAAAAJlFbqM5DlKR2-4UowIY427A092R" (resolved)=resolvedCaptchaToken($event)
            formControlName="recaptchaReactive"></re-captcha>
          <button [disabled]="reactiveForm.invalid" (click)="submitXA()"
            class="btn btn-custom btn-primary btn-continue btn-lg btn-block" style="margin-top: 10px;">Submit</button>
        </form>
      </div>


      <button *ngIf="!captchaRequired" (click)="submitXA()"
        class="btn btn-custom btn-continue btn-block funding-submit">
        Continue
      </button>
    </div>
  </div>

</form>